import { EMPTY_OBJECT } from '../../../../constants/common'
import { ControlRadioGroup } from '../ControlRadioGroup'

import { control } from './control'

/**
 * @param {string} name
 * @param {*} value
 * @param {Object} defaultProps
 */
export function radioGroup(name, value, defaultProps = EMPTY_OBJECT) {
  return control(name, value, ControlRadioGroup, defaultProps)
}
